import { withInstall } from '@ideaz/utils'
import CheckCardItem from './src/CheckCardItem'
import CheckCard from './src'

export default { ZCheckCard: withInstall(CheckCard), ZCheckCardItem: withInstall(CheckCardItem) }
export * from './src/props'
